import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe takes a language key
 * and transforms it to its language displayName.
 *
 * Optionally shows the region in parentheses when showRegion is true.
 * e.g. 'de-DE' → 'Deutsch' or 'Deutsch (Deutschland)'
 *
 * @param value string of source locale
 * @param showRegion boolean — when true, includes region name in parentheses
 */
@Pipe( {
    name: 'localePipe',
    standalone: true,
    pure: true
} )
export class LocalePipe implements PipeTransform {
    /**
     * helper function to convert a given language key
     * into a representation of key language
     *
     * @example
     * <!-- without region (default) -->
     * transform('de-DE') → 'Deutsch'
     *
     * <!-- with region -->
     * transform('de-DE', true) → 'Deutsch (Deutschland)'
     * transform('de-AT', true) → 'Deutsch (Österreich)'
     *
     * @param key - language key e.g. 'de-DE'
     * @param showRegion - when true, includes region name in parentheses
     * @returns string containing language displayName
     */
    transform( key: string, showRegion = false ): string {
        if ( key === null || key === undefined || key === '' ) return '';

        const baseKey = key.split( '-' )[ 0 ];

        if ( showRegion && key.includes( '-' ) ) {
            // show full locale name including region e.g. 'Deutsch (Deutschland)'
            const dn = new Intl.DisplayNames( [ baseKey ], { type: 'language' } ).of( key );
            return '' + dn;
        }

        // show base language name only e.g. 'Deutsch'
        const dn = new Intl.DisplayNames( [ baseKey ], { type: 'language' } ).of( baseKey );
        return '' + dn;
    }
}
